<template>
  <div class="content" :class="{'autoHeight':isShowMenu}">
    <Header @showMenu="showMenuEvent"></Header>
    <div class="home-content">
      <div class="home-page por">
        <div class="ac fw7" style="font-size: 40px;margin-top: -70px;text-shadow: 4px 4px 0 #001d8c;">
          <span class="">{{ $t('GrabGet') }}</span>
        </div>
        <div style="font-size: 26px" class="tips mt30 ac" v-html="$t('ChooseTips1')"></div>
        <div class="tab">
          <span class="tab-li" @click="tabClick(1)" :class="{'active':activeTab==1}">{{ $t('LvL_1') }}</span>
          <span class="tab-li" @click="tabClick(2)" :class="{'active':activeTab==2}">{{ $t('LvL_2') }}</span>
          <span class="tab-li" @click="tabClick(3)" :class="{'active':activeTab==3}">{{ $t('LvL_3') }}</span>
        </div>
        <div class="home1-product2">
          <div>
            <div class="ac" style="font-family: Arial, Helvetica, sans-serif;width: 60%;margin: 0 auto 30px;">
              {{ $t('homefont2') }}
            </div>
            <div class="product2-content disflex">
              <div class="product2-list" v-for="(item,index) in info.hot">
                <div class="home1-img2" @click="goPlay()">
                  <img v-if="activeTab==1" src="../../static/images/img1.png"/>
                  <img v-if="activeTab==2" src="../../static/images/img3.png"/>
                  <img v-if="activeTab==3" src="../../static/images/img6.png"/>
                </div>
                <div class="product2-bottom">
                  <button class="btn btn-blue" @click="goPlay()">{{ $t('play') }}</button>
                </div>
              </div>
            </div>
            <div style="text-align: center">
              <span v-if="activeTab==1">{{$t('level_tip1')}}</span>
              <span v-if="activeTab==2">{{$t('level_tip2')}}</span>
              <span v-if="activeTab==3">{{$t('level_tip3')}}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="modal defModal" v-if="isShow">
      <div class="modal-bg" style="background: rgba(0,0,0,.2);"></div>
      <div class="modal-content" style="width: 100%;margin-left: -50%;">
        <div class="modal-content2">
          <img width="" src="../../static/images/prize.gif"/>
        </div>
      </div>
    </div>
    <!-- 抽奖弹窗-->
    <Dialog ref="saveDialog" type="alert" :callback="saveModal" title="Reminder" width="100" :btnText="$t('goBack')" :cancelText="$t('goBack')">
      <div class="" slot="mdBox">
        <div class="home-modal" v-if="modalList.list &&modalList.list.level>0">
          <div class="fw7" style="text-shadow: 3px 3px 0 #001d8c;font-size: 40px;padding-top: 60px;">{{modalList.list.name}}</div>
          <img width="" style="width:60%;border-radius: 40px;" :src="modalList.list.image"/>
          <div class="home-bt">
            <div class="idx-t">{{modalList.list.level_name}}</div>
            <div class="idx-b mt50">
              <div class="" style="font-weight: 700;">{{modalList.tip}}!</div>
              <div class="" style="font-size: 24px;margin-top: 20px;">{{$t('Card Name')}}     -      {{modalList.list.name}}</div>
            </div>
          </div>
        </div>
        <div class="home-modal" v-else>
            <div class="fw7" style="text-shadow: 3px 3px 0 #001d8c;font-size: 40px;padding-top: 60px;">{{$t('Thank You')}}</div>
            <img width="" style="width:40%;border-radius: 40px;margin: 30px 0;" src="../../static/images/robot-nt.png"/>
            <div class="home-bt">
              <div class="idx-t">{{$t('no prize found')}}</div>
              <div class="idx-b mt50">
                <div class="" style="font-weight: 700;">{{$t('Better luck next time!')}}!</div>
                <div class="" style="font-size: 24px;margin-top: 20px;">{{$t('Card Name')}}     -      {{$t('Thank You')}}</div>
              </div>
            </div>
        </div>
      </div>
    </Dialog>
    <!-- 邀请成功弹窗-->
    <Dialog ref="subscribeDialog" type="alert" :callback="getSubmit" title="Reminder" width="100" :modalFoot="false" :btnText="$t('OK')" :cancelText="$t('OK')">
      <div class="invited-c ac" slot="mdBox" style="">
        <div class="invited-l">
          <div class="pt20 ac" style="padding-top:10px;font-weight: 700;">
            {{ $t('alertTips') }}
          </div>
          <img style="width: 80%; margin: 30px 0 -10px;" src="../../static/images/robot-img.png">
          <div class="" style="margin: 40px 10px 0;font-size: 24px;">
            <div style="font-size:40px">{{$t('Invitation successful!')}}</div>
               <div class="" style="width: 70%;margin: 10px auto 30px;">{{$t('invitTips1')}}</div>
          </div>
          <button class="btn-yl" @click="getSubmit">{{ $t('OK') }}</button>
        </div>
      </div>
    </Dialog>
    <!-- 购买确认弹窗-->
    <Dialog ref="buyDialog" type="alert" :callback="getBuy" title="Reminder" width="100" :modalFoot="false">
      <div class="invited-c ac" slot="mdBox" style="">
        <div class="invited-l">
          <div class="pt20 ac" style="padding-top:10px;font-weight: 700;">
            {{ $t('buy_popup_tip1') }}
          </div>
          <img style="width: 80%; margin: 30px 0 -10px;" src="../../static/images/robot-img.png">
          <div class="" style="margin-top: 120px;font-size: 24px;">
            <div class="" style="width: 70%;margin: 10px auto 30px;">{{$t('buy_popup_tip2')}}</div>
          </div>
          <button class="btn6 font-family mt20" style="width: 280px;line-height: 103px;color: #fff;font-size: 30px;" @click="closeBuyPopup">{{$t('cancel')}}</button>
          <button style="width: 280px;height: 104px;" class="btn-yl font-family mt20" @click="getBuy()">{{$t('buyNow')}}</button>
        </div>
      </div>
    </Dialog>
    <!--    winer弹窗-->
    <div class="modal login-modal" v-if="isShow3">
      <div class="modal-bg"></div>
      <div class="modal-content modal-content2">
        <img :src="popupImage"/>
        <div class="close ac app-en" @click="getClose">x</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '../components/header'
import Footer from '../components/footer'
import Dialog from '../components/dialog'
import DailyLogin from '../components/dailyLogin'

export default {
  components: {
    Header, Dialog, Footer, DailyLogin
  },
  data() {
    return {
      info: {},
      user_id: 0,
      isShow: false,
      isShow2: false,
      isShow3: false,
      keywords: '',
      notFound: false,
      indexImg: [],
      clickIndex: '',
      modalList: {
        'list': [],
      },
      draw_num: '',
      game_num: '',
      answerT: '',
      isEN: 'bur',
      popupImage: null,
      isShowMenu: false,
      miao: null,
      activeTab:1

    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.isEN = localStorage.getItem('lang')?localStorage.getItem('lang'):"bur";
    this.info.hot = [
      {
        title: 'choose me',
        img: '../../static/images/img1.png',
      },
      {
        title: 'choose me',
        img: '../../static/images/img2.png',
      }, {
        title: 'choose me',
        img: '../../static/images/img3.png',
      }, {
        title: 'choose me',
        img: '../../static/images/img4.png',
      }, {
        title: 'choose me',
        img: '../../static/images/img5.png',
      }, {
        title: 'choose me',
        img: '../../static/images/img6.png',
      },
    ]
  },
  methods: {
    showMenuEvent(event) {
      console.log(event)
      this.isShowMenu = event
    },
    getRuleTask(url) {
      this.$router.push({path: '/'+url});
    },
    goGameList() {
      this.$router.push({path: '/gameList',query:{user_id:this.user_id}});
    },
    saveModal() {
      this.$refs.saveDialog.closeMask()
      this.isShow2 = true;
    },
    tabClick(index){
      this.activeTab = index
    },
    goPlay(index) {
      let that = this
      let data = {
        'pay_times': index,
        'level':that.activeTab
      }
      that.modalList = {}
      that.$parent.loadModal(true);
      that.$api.post('/api/index/lottery', data, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.isShow = true;
          that.modalList = r.data
          that.draw_num = r.data.draw_num
          setTimeout(function () {
            that.isShow = false;
            that.$refs.saveDialog.showMaskFun();
          }, 2000);
        })
      })
    },
    getSubmit() {
      this.$refs.subscribeDialog.closeMask();
    },
    getBuy() {
      let that = this
      let data = {}
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy', data, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 80);
          that.getHome();
        })
      })
    },
    fastLogin() {
      let that = this
      that.$parent.loadModal(true);
      let data = {
        'mobile': this.$route.query.mobile
      }
      that.$api.post('/api/user/fast_login', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          localStorage.setItem('token', r.data.userinfo.token)
          localStorage.setItem('mobile', r.data.userinfo.mobile)
          this.getHome();
        } else {
          that.$utils.alertText(r.msg, 80);
          this.$router.push({path: 'land'})
        }
      })
    },
    getClose() {
      this.isShow3 = false
    },
    showBuyPopup(){
      this.$refs.buyDialog.showMaskFun();
    },
    closeBuyPopup(){
      this.$refs.buyDialog.closeMask();
    }
  }
}
</script>
<style scoped>
.bgfff {
  background: #fff !important;
}

.invited-c {
  background: url(../../static/images/invited-bg.jpg) no-repeat center top;
  color: #fff;
  padding: 40px;
  margin: 0 auto;
  border-radius: 40px;
  font-family: arial;
  text-align: left;
  width: 680px;
  height: 893px;
}

.border-li {
  padding: 15px 0;
}

.login {
  margin-top: 240px;
}

.modal-footer .btn {
  width: 48%;
  background-size: cover;
  min-height: 120px;
}


.modal-content2 {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -10px;
  border-radius: 8px;
  margin-left: -45%;
  width: 90%;
}

.modal-content2 img {
  border-radius: 40px;
  width: 90%;
}

.close {
  background: rgb(255 255 255 / 20%);
  color: #fff;
  width: 100px;
  height: 100px;
  font-size: 60px;
  margin: 30px auto 0;
  border-radius: 100px;
}
</style>



// WEBPACK FOOTER //
// src/page/cards.vue